var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',[_c('img',{attrs:{"src":require("../../assets/images/loading.gif")}}),(!!_vm.description)?_c('span',[_vm._v(_vm._s(_vm.description))]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }